import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Input } from '../../components';
import { icons } from '../../assets';
import * as s from './styled-register';

const Informacoes = ({
  username,
  email,
  phoneNumber,
  setUsername,
  setEmail,
  setPhoneNumber,
}) => {
  const { colors } = useContext(ThemeContext);

  return (
    <s.FormContainer url="RegisterOpaqueRight.svg">
      <div id="content">
        <s.Title>Cadastrar</s.Title>
        <s.Wrapper input>
          <s.Label size="13px" color={colors.darkblue} bold>
            Nome completo
          </s.Label>
          <Input
            src={icons.PersonIcon}
            placeholder="Digite seu nome completo"
            width="500px"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            noPadding
          />
        </s.Wrapper>
        <s.Wrapper input>
          <s.Label size="13px" color={colors.darkblue} bold>
            Número de telefone
          </s.Label>
          <div id="phone">
            <s.Icon src={icons.PhoneIcon} margin="15px" size="30px" />
            <s.MaskedInput
              placeholder="Digite seu número de telefone"
              mask="(99)99999-9999"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>
        </s.Wrapper>
        <s.Wrapper input>
          <s.Label size="13px" color={colors.darkblue} bold>
            E-mail
          </s.Label>
          <Input
            src={icons.EmailIcon}
            placeholder="Digite seu e-mail"
            width="500px"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            noPadding
          />
        </s.Wrapper>
      </div>
    </s.FormContainer>
  );
};

export default Informacoes;
